import request, { liveDataApiUrl } from 'services/request';
import { CodalReportsUrl, SupervisorMessagesUrl } from 'routes/security.routes';
import { SupervisorMessageType } from 'typings/security.type';

export const getSecurityCodalReportDataAction = async (
  set,
  id: string,
  page: number,
): Promise<void> => {
  set((state) => ({
    // the exist data in store should be clear if the security id changed, and it does not changed the last data of store should be keep as it is
    ...(id !== state.codalId && {
      codalReportData: null,
      codalPageNumber: 1,
      codalDataCount: 0,
    }),
    codalReportLoading: page === 1,
    codalReportError: false,
  }));

  const response = await request.get(CodalReportsUrl(id), {
    page,
    page_size: 10,
  });

  const responseData = response?.data?.data;
  response.ok
    ? set((state) => ({
        codalReportLoading: false,
        codalReportError: false,
        codalPageNumber: responseData.page,
        codalDataCount: responseData.count,
        codalId: id,
        codalReportData: responseData.results.length
          ? [...(state.codalReportData || []), ...responseData.results]
          : [],
      }))
    : set({
        codalReportLoading: false,
        codalReportError: true,
      });
};

export const getSupervisorMessageData = async (
  set,
  id: string,
  page: number,
): Promise<void> => {
  set((state) => ({
    // the exist data in store should be clear if the security id changed, and it does not changed the last data of store should be keep as it is
    ...(id !== state.supervisorMessageId && {
      supervisorMessageData: null,
      supervisorMessagePageNumber: 1,
      supervisorMessageDataCount: 0,
    }),
    supervisorMessageLoading: page === 1,
    supervisorMessageError: false,
  }));

  const response = await request.get(
    liveDataApiUrl + SupervisorMessagesUrl(id),
    {
      page,
      page_size: 10,
    },
  );

  const responseData = response?.data;
  response.ok
    ? set((state) => ({
        supervisorMessageLoading: false,
        supervisorMessageError: false,
        supervisorMessagePageNumber: responseData.page,
        supervisorMessageDataCount: responseData.count,
        supervisorMessageId: id,
        supervisorMessageData: responseData.results.length
          ? [...(state.supervisorMessageData || []), ...responseData.results]
          : [],
      }))
    : set({
        supervisorMessageLoading: false,
        supervisorMessageError: true,
      });
};
// this action will set socket data of current supervisor message to keep the data
// and prevent losing socket data if the user gets back and return to supervisor message page
export const addNewSupervisorMessageAction = async (
  set,
  message: SupervisorMessageType,
): Promise<void> => {
  set((state) => ({
    supervisorMessageData:
      state.supervisorMessageData[0].id !== message.id
        ? [message, ...state.supervisorMessageData]
        : state.supervisorMessageData,
  }));
};
